var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-table',{ref:"modOnlineTable",attrs:{"url":"/api/v1/moderator","filter":_vm.filter,"appends":['dialogInModeration'],"attributes":[
      {
        name: 'Moderator',
        type: 'UserNoEmailCell',
        attribute: 'user',
        sortable: false
      },
      {
        attribute: 'customer',
        name: 'Mitglied',
        type: _vm.customerCell,
        sortable: false
      },
      {
        attribute: 'fake',
        name: 'Fake',
        type: 'LinkProfileCell',
        sortable: false
      },
      {
        attribute: 'dialogInModeration.dialog_id',
        name: 'Dialog',
        type: 'DialogInfoCell',
        sortable: false
      },
      {
        attribute: 'dialogInModeration.updated_at',
        name: 'Gesprächsdauer',
        type: 'TimeCounterCell',
        sortable: false
      },
      {
        attribute: 'dialogInModeration.last_message_at',
        name: 'Wartezeit Mitglied',
        type: 'TimeCounterCell',
        sortable: false
      },
      {
        attribute: 'recentMessages',
        name: 'Leistung',
        type: 'ModeratorEfficencyCell',
        sortable: false
      },
      {
        name: 'Aktionen',
        type: 'ModeratorInformationActionCell',
        sortable: false
      }
    ]},on:{"table-fetched":_vm.tableFetched}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      Moderatoren Information\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }